'use client';
import React from 'react';
// eslint-disable-next-line nextjs-boundaries/no-server-import-in-client
import { GameTileImageMobile } from '@/app/components/game/subcomponents/explore-row/mobile/game-tile-image/game-tile-image';
import { InfoButton } from '@/app/components/game/subcomponents/info-button';
// eslint-disable-next-line nextjs-boundaries/no-server-import-in-client
import { SocialTagBadge } from '@/app/components/badge/layouts/social-tag/social-tag-badge';
import type { SocialTagBadgeState } from '@/types/games';
import { GameUrl } from '@/app/components/game/subcomponents/game-url/game-url';
import type { LauncherUrlProps } from '@/utils/url/launcher-url';

import './styles/@theme';
// eslint-disable-next-line nextjs-boundaries/no-server-import-in-client
import { NotificationIcon } from '@/app/elements/notification-icon/notification-icon';

type ExploreDetailsProps = {
    title: string;
    info: string;
    logo: string;
    background: string;
    uid: string;
    launcherUrlProps: LauncherUrlProps;
    showNotificationIcon: boolean;
    socialTagBadgeState?: SocialTagBadgeState;
    uniquePlayersCount?: number;
};

export const ExploreDetails = ({
    title,
    info,
    logo,
    background,
    uid,
    uniquePlayersCount,
    socialTagBadgeState,
    launcherUrlProps,
    showNotificationIcon
}: ExploreDetailsProps) => {
    return (
        <div className="explore-details-container">
            <GameUrl launcherUrlProps={launcherUrlProps}>
                <div className="tile layout-explore">
                    {showNotificationIcon && <NotificationIcon />}
                    <GameTileImageMobile logoUrl={logo} backgroundUrl={background}></GameTileImageMobile>
                </div>
                <div className="text-details">
                    <p className="title">{title}</p>
                    <div className="info-container">
                        <SocialTagBadge
                            state={socialTagBadgeState}
                            uniquePlayersCount={uniquePlayersCount}
                            hidePlayingText={true}
                        />
                        <p className="info">{info}</p>
                    </div>
                </div>
            </GameUrl>
            <InfoButton uid={uid} />
        </div>
    );
};
